module.exports = __webpack_public_path__ + "img/orange_015.5ca55bcc.png";